import { selectGarageCarportCost } from '../../../redux/features/selectors/costSelectors/selectGarageCarportCost.ts';
import { selectImprovementsGarageCarport } from '../../../redux/features/selectors/propertyDataSelectors/improvementsSelectors.ts';
import { CostApproachTableCostRow } from '../CostApproachTableCostRow.tsx';

export const GarageCarportCostRow = () => (
  <CostApproachTableCostRow
    label="Garage/Carport"
    areaSelector={selectImprovementsGarageCarport}
    costSelector={selectGarageCarportCost}
  />
);
